import { useEffect } from 'react'

import { useAuth } from '../auth/useAuth'
import { useTheme } from './useTheme'
import { normalizeTheme } from './theme'

/**
 * Aplikuje motyw zapisany w profilu użytkownika (settings.user.theme),
 * na wzór I18nProfileSync. Brak preferencji = zostaje motyw lokalny.
 */
export default function ThemeProfileSync() {
  const { profile } = useAuth()
  const { theme, setLocalTheme } = useTheme()
  const preferredTheme = normalizeTheme(profile?.settings?.user?.theme)

  useEffect(() => {
    if (!preferredTheme || preferredTheme === theme) {
      return
    }
    setLocalTheme(preferredTheme)
  }, [preferredTheme, setLocalTheme, theme])

  return null
}
